module.exports = function () {
  return {
    get: get,
    set: set,
    mget: mget,
    mset: mset,
    flush: flush
  };
};

function get() {
  return Promise.resolve(null);
}

function set() {
  return Promise.resolve(true);
}

function mget(keys) {
  var values = keys.map(function (x) {
    return null;
  });
  return Promise.resolve(values);
}

function mset() {
  return Promise.resolve(true);
}

function flush() {
  return Promise.resolve(true);
}